export const SCHEMA_FAMILIES = {
  source: 'landing-families',

  map: { contactName: 'parent_name', email: 'email', phone: 'phone', message: 'notes' },

  schoolName(a) {
    if (a.program_type === 'private') return 'Acuity Technical Academy';
    if (a.program_type === 'homeschool') return 'Acuity Parent Teacher Support Program';
    return '(family enquiry)';
  },

  confirmTail: "team will review what you've shared and follow up by email with next steps.",

  sections: [
    {
      legend: 'About you',
      help: 'The parent or guardian we should contact.',
      fields: [
        { id: 'parent_name', label: 'Full name', type: 'text', required: true,
          autocomplete: 'name', errorMessage: 'Please enter your name.' },
        { id: 'email', label: 'Email', type: 'email', required: true,
          autocomplete: 'email', placeholder: 'you@example.com' },
        { id: 'phone', label: 'Phone', type: 'tel', required: true, autocomplete: 'tel',
          errorMessage: 'Please enter a phone number.' },
        { id: 'state', label: 'State', type: 'select', required: true,
          placeholder: 'Select a state…', options: 'US_STATES' },
        { id: 'city_or_zip', label: 'City or ZIP code', type: 'text', required: true, full: true,
          autocomplete: 'postal-code', placeholder: 'Helps us match you to the right school',
          errorMessage: 'Please enter your city or ZIP code.' }
      ]
    },
    {
      legend: "What you're looking for",
      help: 'This tells us which program to talk to you about.',
      fields: [
        { id: 'program_type', label: 'Registering for', type: 'radio', required: true, full: true,
          options: [
            { value: 'private', label: 'Acuity Technical Academy',
              hint: 'Private school enrollment.' },
            { value: 'homeschool', label: 'Acuity Parent Teacher Support Program',
              hint: "For parents who want resources, tools, and support for facilitating their child's learning." }
          ] },

        { id: 'child_count', label: 'How many children are you registering?', type: 'select',
          required: true, options: ['1', '2', '3', '4', '5'] },

        { id: 'students', label: 'Student details', type: 'roster', required: true,
          countField: 'child_count', max: 5, itemLabel: 'Student',
          help: "Please give each child's name and the grade they'll be entering.",
          errorMessage: 'Please complete the name and grade for each child.',
          fields: [
            { id: 'first_name', label: 'First name', type: 'text' },
            { id: 'last_name', label: 'Last name', type: 'text' },
            { id: 'grade', label: 'Grade for the coming year', type: 'select', full: true,
              placeholder: 'Select a grade…',
              options: [{ value: 'K', label: 'Kindergarten' },
                        { value: '1', label: 'Grade 1' }, { value: '2', label: 'Grade 2' },
                        { value: '3', label: 'Grade 3' }, { value: '4', label: 'Grade 4' },
                        { value: '5', label: 'Grade 5' }, { value: '6', label: 'Grade 6' },
                        { value: '7', label: 'Grade 7' }, { value: '8', label: 'Grade 8' },
                        { value: '9', label: 'Grade 9' }, { value: '10', label: 'Grade 10' },
                        { value: '11', label: 'Grade 11' }, { value: '12', label: 'Grade 12' }] }
          ] },

        { id: 'target_start', label: 'When would you like to start?', type: 'select', required: true,
          options: ['As soon as possible', 'This semester', 'Next semester',
                    'Next school year', 'Just exploring'] },
        { id: 'current_schooling', label: 'Where is your child learning now?', type: 'select',
          options: ['Public school', 'Private school', 'Homeschool',
                    'Not currently enrolled', 'Other'] },
        { id: 'referral_source', label: 'How did you hear about us?', type: 'select',
          options: ['Search engine', 'Social media', 'Friend or family',
                    'School or teacher', 'Event or fair', 'Other'] },
        { id: 'notes', label: 'Anything else we should know?', type: 'textarea', full: true,
          placeholder: 'Questions, learning needs, timelines — anything that helps us prepare.' }
      ]
    }
  ]
};
